module.exports = __webpack_public_path__ + "static/media/NCA_Cent.64aef11b.png";